import { TemplateRef } from '@angular/core';

export class ConfirmSidebar<T = any> {
  title?: string;
  okText?: string;
  cancelText?: string;
  contentMessage?: string;
  hideCloseButton?: boolean;
  hideOkButton?: boolean;
  hideCancelButton?: boolean;
  template?: TemplateRef<HTMLElement>;
  templateData?: T | any;
  isReasonSidebar?: boolean;
  imageSrc?: string;
  icon?: string;
}
